import { Flex, Heading } from "@braze/beacon-core"
import { RoundedCard } from "../../shared/RoundedCard"
import { useColor } from '@braze/beacon-styling';
import { JIRA_CLOUD_URL } from "../../shared/JiraMigrationBanner";
import styled from "styled-components";

export const Home = () => {
    const colorGetter = useColor();

    return (
        <RoundedCard style={{ width: "60%" }}>
            <Flex direction="column" justifyContent="center" style={{ width: '100%' }}>
                <Heading style={{ color: colorGetter("red", 300), textAlign: "center" }}>
                    Welcome to Braze Campaign Builder!
                </Heading>
                <DescriptionLabel>Please submit all Campaign Builder requests in {" "}
                    <a href={JIRA_CLOUD_URL} target="_blank" rel="noopener noreferrer">
                        Jira Cloud
                    </a>
                    .
                </DescriptionLabel>
            </Flex>
        </RoundedCard>
    )
};

const DescriptionLabel = styled.p`
    margin-top: 1rem;
    text-align: center;
    font-size: 16px;
    font-weight: normal;

    a {
        color: #7c3aed;
        font-weight: 600;
        text-decoration: underline;
    }
`;
